import { useMutation } from '@tanstack/react-query';
import { useFetcher } from '../../graphql';
import { CallTokenResult } from './useStartCall';

/**
 * Ring every Workspace Admin for an Activity (Issue) — fans out one RINGING
 * Call per admin sharing room `activity-<issueId>`. Resolves with the
 * caller's LiveKit token + server url so the caller can join the room and
 * wait for an admin to answer (≈ startCall, but for a group/Activity call).
 */
export const useRingActivityCall = () => {
  const fetcherFn = useFetcher<
    { call: { ringActivityCall: CallTokenResult } },
    { input: { issueId: string } }
  >(RING_ACTIVITY_CALL);

  return useMutation({
    mutationFn: async (issueId: string): Promise<CallTokenResult> => {
      const data = await fetcherFn({ input: { issueId } });
      return data.call.ringActivityCall;
    },
  });
};

const RING_ACTIVITY_CALL = `
  mutation RING_ACTIVITY_CALL($input: RingActivityCallInput!) {
    call {
      ringActivityCall(input: $input) {
        call {
          id
          room
          state
          caller { id }
          callee { id }
        }
        token
        url
      }
    }
  }
`;
